// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{box-sizing:border-box;font-display:swap;font-family:\"Inter\",sans-serif;margin:0;padding:0}h2{font-weight:700}.auth-modal .ant-modal-title{color:#000;font-display:swap;font-family:\"Mulish\";font-size:20px;font-style:normal;font-weight:700;line-height:25px}@media only screen and (max-width:500px){body{width:100%!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
